module.exports = __webpack_public_path__ + "static/fictionGif-8a0313610d4d116f91b5f5ad7b3a2311.mp4";